export default "__VITE_ASSET__zKqhs7sJ__"